var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"page_"},[_c('div',{staticClass:"close",on:{"click":_vm.close}},[_vm._v("X")]),_c('div',{staticClass:"content",domProps:{"innerHTML":_vm._s(_vm.content)}})])
}
var staticRenderFns = []

export { render, staticRenderFns }